<ng-template #modal>
  <div class="modal-header">
    <h4 i18n class="modal-title">Moderation comment</h4>

    <button class="border-0 p-0" title="Close this modal" i18n-title (click)="hide()">
      <my-global-icon iconName="cross"></my-global-icon>
    </button>
  </div>

  <div class="modal-body">
    <form novalidate [formGroup]="form" (ngSubmit)="banUser()">
      <div class="form-group">
        <textarea
          formControlName="moderationComment" ngbAutofocus i18-placeholder placeholder="Comment this report…"
          [ngClass]="{ 'input-error': formErrors['moderationComment'] }" class="form-control">
        </textarea>
        <div *ngIf="formErrors.moderationComment" class="form-error" role="alert">
          {{ formErrors.moderationComment }}
        </div>
      </div>

      <div class="form-group" i18n>
        This comment can only be seen by you or the other moderators.
      </div>

      <div class="form-group inputs">
        <input
          type="button" role="button" i18n-value value="Cancel" class="peertube-button grey-button"
          (click)="hide()" (key.enter)="hide()"
        >

        <input type="submit" i18n-value value="Update this comment" class="peertube-button orange-button" [disabled]="!form.valid" />
      </div>
    </form>
  </div>

</ng-template>
